export const PageTitleStyles = {
    title: "text-2xl font-medium",
}